import React, {Component} from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import {searchFees} from './actions';
import {bindActionCreators} from "redux";
import ListView from "../common/ListView";
import {Link} from "react-router-dom";

const columns = [
  {
    title: 'Name',
    dataIndex: 'name',
    key: 'name',
    sorter: true,
  },
  {
    title: 'Description',
    dataIndex: 'lineItemDescription',
    key: 'lineItemDescription',
    sorter: true,
  },
  {
    title: 'Tax Group',
    dataIndex: 'taxGroupName',
    key: 'taxGroupName',
    sorter: true,
  },
  {
    title: 'Applicable Products',
    dataIndex: 'applicableProductCount',
    key: 'applicableProductCount'
  },
  {
    title: 'Action',
    key: 'action',
    render: (_, {feeId}) => {
      const encodedId = encodeURIComponent(feeId);
      return (
        <React.Fragment>
          <Link to={`/fee/update/${encodedId}`}>Edit</Link>
          {' | '}
          <Link to={`/fee/rates/${encodedId}`}>Rates</Link>
          {' | '}
          <Link to={`/fee/applicable-products/${encodedId}`}>Applicable Products</Link>
        </React.Fragment>
      );
    }
  }
];

class FeesPage extends Component {
  static propTypes = {
    history: PropTypes.object.isRequired,
    dispensaryId: PropTypes.string.isRequired,
    search: PropTypes.object.isRequired,
    searchFees: PropTypes.func.isRequired,
  };

  render() {
    const {
      dispensaryId, history, searchFees, search: {searching, pagination, filters, sorter, results, searchFilter},
    } = this.props;
    return (
      <ListView
        title="Fees"
        loading={searching}
        columns={columns}
        dataSourceProvider={searchFees}
        dataSource={results}
        pagination={pagination}
        filters={filters}
        sorter={sorter}
        searchFilter={searchFilter}
        dispensaryId={dispensaryId}
        rowKey="feeId"
        onAdd={() => history.push('/fee/add')}
      />
    );
  }
}

const mapStateToProps = state => ({
  dispensaryId: state.dispensary.selectedDispensaryId,
  search: state.fee.searchFees,
});

const mapDispatchToProps = dispatch => ({
  searchFees: bindActionCreators(searchFees, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(FeesPage);



// WEBPACK FOOTER //
// ./src/Fee/FeesPage.js